import React from "react";
import Spinner from "../Spinner/Spinner";

const Loading = () => {
  return (
    <div className="flex justify-center mt-10">
      <div className="flex justify-center items-center text-center flex-col">
        <Spinner />
        <div className="mt-6 text-gray-600">
          Here's your chance to reheat your coffee.
        </div>
        <div className="mt-6 text-gray-600">
          Aquí está su oportunidad para recalentar el café…
        </div>
        <div className="mt-6 text-gray-600">这是您重新加热咖啡的机会…</div>
        <div className="mt-6 text-gray-600">
          Vous avez le temps de vous préparer un café…
        </div>
        <div className="mt-6 text-gray-600">
          Agora é a oportunidade de requentar seu café…
        </div>
      </div>
    </div>
  );
};

export default Loading;
